const danhSachVaiTro = state => state.danhSachVaiTro;
const chiTietVaiTro = state => state.chiTietVaiTro;
const danhSachQuyenTheoVaiTro = state => state.danhSachQuyenTheoVaiTro;
const danhSachQuyenKhongThuocVaiTro = state =>
  state.danhSachQuyenKhongThuocVaiTro;
const danhSachNguoiDungTheoVaiTro = state => state.danhSachNguoiDungTheoVaiTro;
const danhSachNguoiDungKhongThuocVaiTro = state =>
  state.danhSachNguoiDungKhongThuocVaiTro;
const danhSachVaiTroTheoApp = state =>
  state.danhSachVaiTroTheoApp;
const danhSachVaiTroKhongThuocGroup = state => state.danhSachVaiTroKhongThuocGroup;
// const danhSachNguoiDungTheoGroup = state => state.danhSachNguoiDungTheoGroup;

export default {
  danhSachVaiTro,
  danhSachQuyenTheoVaiTro,
  danhSachQuyenKhongThuocVaiTro,
  chiTietVaiTro,
  danhSachNguoiDungTheoVaiTro,
  danhSachNguoiDungKhongThuocVaiTro,
  // danhSachNguoiDungTheoGroup
  danhSachVaiTroTheoApp,
  danhSachVaiTroKhongThuocGroup
};
